import React, { useRef, useState, useEffect } from "react";
import HTMLFlipBook from "react-pageflip";
import Modal from "react-modal";
import "./FlipBook.css";
import "./AllCourseCommonStyle.css";
import WelcomeName from "../WelcomeName.jsx";
import { useSelector, useDispatch } from "react-redux";
import { getCourseData } from "../../Redux/FlipbookData.js";
import { CircularProgress } from "@mui/material";

const getPageNum = (courseName, data) => {
  const num = data?.pages?.find((item) => item?.courseName === courseName);
  return num?.pageNumber;
};

const isEven = (number) => {
  return number % 2 === 0;
};

const PageCover = React.forwardRef((props, ref) => {
  return (
    <div className="page page__cover" ref={ref}>
      <div className="page__layout__container">
        <div className="pageCover">
          <img src={props.src} className="cover__image__size" alt="cover" />
        </div>
        <div className="page_number__bottom">{props.number}</div>
      </div>
    </div>
  );
});

const Page = React.forwardRef((props, ref) => {
  if (props?.courseName === "Table of Contents") {
    const mapArray =
      props?.header !== "header_img2" && props?.header !== ""
        ? props?.contentsArray[0]
        : props?.courses;
    return (
      <div className="page page__cover" ref={ref}>
        <div className="page__layout__container">
          {props?.header !== "header_img2" && props?.header !== "" && (
            <h5 className="table__header1">{props.header}</h5>
          )}
          <table
            className={
              props?.header === "header_img2" || props?.header === ""
                ? "myTable1 tableHeaderStyle"
                : "myTable1"
            }
          >
            <tr className="tr__th">
              <th className="th__sl">{props?.tableHeaders[0]}</th>
              <th className="th__topic">{props?.tableHeaders[1]}</th>
              <th className="th__page">{props?.tableHeaders[2]}</th>
            </tr>
            {props?.header !== "header_img2" && props?.header !== "" && (
              <>
                <tr
                  onClick={() =>
                    props?.book?.flip(
                      getPageNum("Introduction", props?.flipBookData) + 2,
                    )
                  }
                >
                  <td className="td__sl">I</td>
                  <td className="td__topic">{props?.tableContent?.intro}</td>
                  <td className="td__page">
                    {getPageNum("Introduction", props?.flipBookData)}
                  </td>
                </tr>
                <tr
                  onClick={() =>
                    props?.book?.flip(
                      getPageNum("Landscape", props?.flipBookData) + 2,
                    )
                  }
                >
                  <td className="td__sl">II</td>
                  <td className="td__topic">
                    {props?.tableContent?.landscape}
                  </td>
                  <td className="td__page">
                    {getPageNum("Landscape", props?.flipBookData)}
                  </td>
                </tr>
                {props?.tableContent?.video !== "" && (
                  <tr
                    onClick={() =>
                      props?.book?.flip(
                        getPageNum("Video", props?.flipBookData) + 2,
                      )
                    }
                  >
                    <td className="td__sl">III</td>
                    <td className="td__topic">{props?.tableContent?.video}</td>
                    <td className="td__page">
                      {getPageNum("Video", props?.flipBookData)}
                    </td>
                  </tr>
                )}
                <tr
                  onClick={() =>
                    props?.book?.flip(
                      getPageNum("Links", props?.flipBookData) + 2,
                    )
                  }
                >
                  <td className="td__sl">
                    {props?.tableContent?.video !== "" ? "IV" : "III"}
                  </td>
                  <td className="td__topic">{props?.tableContent?.links}</td>
                  <td className="td__page">
                    {getPageNum("Links", props?.flipBookData)}
                  </td>
                </tr>
                <tr
                  onClick={() =>
                    props?.book?.flip(
                      getPageNum("Courses At Glance", props?.flipBookData) + 2,
                    )
                  }
                >
                  <td className="td__sl">
                    {props?.tableContent?.video !== "" ? "V" : "IV"}
                  </td>
                  <td className="td__topic">
                    {props?.tableContent?.coursesAtGlance}
                  </td>
                  <td className="td__page">
                    {getPageNum("Courses At Glance", props?.flipBookData)}
                  </td>
                </tr>
              </>
            )}
            <tr className="No_Hover">
              <td className="td__sl">
                {props?.tableContent?.video !== "" ? "VI" : "V"}
              </td>
              <td className="td__topic">
                {props?.tableContent?.coursesInDetail}
              </td>
              <td className="td__page"></td>
            </tr>
            {mapArray?.map((item, index) => {
              return (
                <tr
                  onClick={() =>
                    isEven(props?.pageNumber)
                      ? props?.book?.flip(
                          getPageNum(item.courseName, props?.flipBookData) - 2,
                        )
                      : props?.book?.flip(
                          getPageNum(item.courseName, props?.flipBookData) + 2,
                        )
                  }
                >
                  <td className="td__sl"></td>
                  <td className="td__topic">
                    <p className="number">{item?.number}</p>
                    <p className="number-para">
                      {item?.courseName?.replace(/^\d+\.\s*/, "")}
                    </p>{" "}
                  </td>
                  <td className="td__page">
                    {getPageNum(item.courseName, props?.flipBookData)}
                  </td>
                </tr>
              );
            })}
          </table>
          <div className="page_number__bottom">{props?.pageNumber}</div>
        </div>
      </div>
    );
  } else if (props?.courseName === "Introduction")
    return (
      <div className="page page__cover" ref={ref}>
        <div className="page__layout__container">
          <div>
            <div>
              <div
                className={
                  props?.header === "header_img2" || props?.header === ""
                    ? "introPageContainer intro__page__container"
                    : "intro__page__container"
                }
              >
                {props?.header !== "header_img2" && props?.header !== "" && (
                  <h5 className="intro__page__title">{props?.header}</h5>
                )}
                <p className="intro__page__p">
                  {props?.header !== "header_img2" && props?.header !== "" && (
                    <img
                      src={`Assets/Images/${props?.CourseName}/${props?.CourseName}-introduction.jpg`}
                      alt="intro"
                      className="intro__page__image"
                    />
                  )}
                  {props?.introduction?.b1 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b1}
                    </b>
                  )}{" "}
                  {props?.introduction?.p1}
                  {props?.introduction?.q1 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q1}
                    </p>
                  )}
                  {props?.introduction?.li1 && (
                    <ul className="listStyle">
                      {props?.introduction?.li1?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b2 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b2}
                    </b>
                  )}{" "}
                  {props?.introduction?.p2}
                  {props?.introduction?.q2 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q2}
                    </p>
                  )}
                  {props?.introduction?.li2 && (
                    <ul className="listStyle">
                      {props?.introduction?.li2?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b3 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b3}
                    </b>
                  )}{" "}
                  {props?.introduction?.p3}
                  {props?.introduction?.q3 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q3}
                    </p>
                  )}
                  {props?.introduction?.li3 && (
                    <ul className="listStyle">
                      {props?.introduction?.li3?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b4 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b4}
                    </b>
                  )}{" "}
                  {props?.introduction?.p4}
                  {props?.introduction?.q4 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q4}
                    </p>
                  )}
                  {props?.introduction?.li4 && (
                    <ul className="listStyle">
                      {props?.introduction?.li4?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b5 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b5}
                    </b>
                  )}{" "}
                  {props?.introduction?.p5}
                  {props?.introduction?.q5 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q5}
                    </p>
                  )}
                  {props?.introduction?.li5 && (
                    <ul className="listStyle">
                      {props?.introduction?.li5?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b6 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b6}
                    </b>
                  )}{" "}
                  {props?.introduction?.p6}
                  {props?.introduction?.q6 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q6}
                    </p>
                  )}
                  {props?.introduction?.li6 && (
                    <ul className="listStyle">
                      {props?.introduction?.li6?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b7 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b7}
                    </b>
                  )}{" "}
                  {props?.introduction?.p7}
                  {props?.introduction?.q7 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q7}
                    </p>
                  )}
                  {props?.introduction?.li7 && (
                    <ul className="listStyle">
                      {props?.introduction?.li7?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b8 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b8}
                    </b>
                  )}{" "}
                  {props?.introduction?.p8}
                  {props?.introduction?.q8 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q8}
                    </p>
                  )}
                  {props?.introduction?.li8 && (
                    <ul className="listStyle">
                      {props?.introduction?.li8?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b9 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b9}
                    </b>
                  )}{" "}
                  {props?.introduction?.p9}
                  {props?.introduction?.q9 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q9}
                    </p>
                  )}
                  {props?.introduction?.li9 && (
                    <ul className="listStyle">
                      {props?.introduction?.li9?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b10 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b10}
                    </b>
                  )}{" "}
                  {props?.introduction?.p10}
                  {props?.introduction?.q10 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q10}
                    </p>
                  )}
                  {props?.introduction?.li10 && (
                    <ul className="listStyle">
                      {props?.introduction?.li10?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b11 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b11}
                    </b>
                  )}{" "}
                  {props?.introduction?.p11}
                  {props?.introduction?.q11 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q11}
                    </p>
                  )}
                  {props?.introduction?.li11 && (
                    <ul className="listStyle">
                      {props?.introduction?.li11?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b12 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b12}
                    </b>
                  )}{" "}
                  {props?.introduction?.p12}
                  {props?.introduction?.q12 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q12}
                    </p>
                  )}
                  {props?.introduction?.li12 && (
                    <ul className="listStyle">
                      {props?.introduction?.li12?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b13 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b13}
                    </b>
                  )}{" "}
                  {props?.introduction?.p13}
                  {props?.introduction?.q13 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q13}
                    </p>
                  )}
                  {props?.introduction?.li13 && (
                    <ul className="listStyle">
                      {props?.introduction?.li13?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b14 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b14}
                    </b>
                  )}{" "}
                  {props?.introduction?.p14}
                  {props?.introduction?.q14 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q14}
                    </p>
                  )}
                  {props?.introduction?.li14 && (
                    <ul className="listStyle">
                      {props?.introduction?.li14?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b15 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b15}
                    </b>
                  )}{" "}
                  {props?.introduction?.p15}
                  {props?.introduction?.q15 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q15}
                    </p>
                  )}
                  {props?.introduction?.li15 && (
                    <ul className="listStyle">
                      {props?.introduction?.li15?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b16 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b16}
                    </b>
                  )}{" "}
                  {props?.introduction?.p16}
                  {props?.introduction?.q16 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q16}
                    </p>
                  )}
                  {props?.introduction?.li16 && (
                    <ul className="listStyle">
                      {props?.introduction?.li16?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b17 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b17}
                    </b>
                  )}{" "}
                  {props?.introduction?.p17}
                  {props?.introduction?.q17 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q17}
                    </p>
                  )}
                  {props?.introduction?.li17 && (
                    <ul className="listStyle">
                      {props?.introduction?.li17?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b18 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b18}
                    </b>
                  )}{" "}
                  {props?.introduction?.p18}
                  {props?.introduction?.q18 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q18}
                    </p>
                  )}
                  {props?.introduction?.li18 && (
                    <ul className="listStyle">
                      {props?.introduction?.li18?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b19 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b19}
                    </b>
                  )}{" "}
                  {props?.introduction?.p19}
                  {props?.introduction?.q19 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q19}
                    </p>
                  )}
                  {props?.introduction?.li19 && (
                    <ul className="listStyle">
                      {props?.introduction?.li19?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>
                <p className="intro__page__p">
                  {props?.introduction?.b20 && (
                    <b className="introPage__boldText">
                      {props?.introduction?.b20}
                    </b>
                  )}{" "}
                  {props?.introduction?.p20}
                  {props?.introduction?.q20 && (
                    <p className="intro__page__para_QE">
                      {props?.introduction?.q20}
                    </p>
                  )}
                  {props?.introduction?.li20 && (
                    <ul className="listStyle">
                      {props?.introduction?.li20?.map((item) => {
                        return <li>{item}</li>;
                      })}
                    </ul>
                  )}
                </p>

                {props?.introduction?.image && (
                  <div className="introImageContainer">
                    <img
                      src={props?.introduction?.image}
                      className="introImage"
                    />
                  </div>
                )}

                <div className="Intro_image">
                  <img
                    src="Assets/Azure/Introduction Icon.png"
                    className="Introduction_innovation_image"
                    alt="TOC-img"
                  />
                </div>
              </div>
            </div>
            <div className="page_number__bottom">{props.pageNumber}</div>
          </div>
        </div>
      </div>
    );
  else if (props?.courseName === "Landscape")
    return (
      <div className="page page__cover" ref={ref}>
        <div className="page__layout__container">
          <div>
            <div className="intoTitleStyle">
              <h5 className="intro__page__title ">{props?.header}</h5>
              <img
                className="imageStyle blank__image__size__landscape1"
                src={`Assets/Images/${props?.CourseName}/${props?.CourseName}-landscape.jpg`}
                alt={`${props?.CourseName}`}
              />
            </div>
            <div className="All_icons">
              <img
                className="Landscape_innovation_icon"
                src="Assets/Azure/Landscape_Icon.png"
                alt="azure"
              />
            </div>
            <div className="page_number__bottom">{props.pageNumber}</div>
          </div>
        </div>
      </div>
    );
  else if (props?.courseName === "Video")
    return (
      <div className="page page__cover" ref={ref}>
        <div
          className={
            props?.header === "header_img2" || props?.header === ""
              ? "layoutContainerStyle page__layout__container"
              : "page__layout__container"
          }
        >
          <div>
            <h5 className="intro__page__title">
              {props?.header !== "header_img2" && props?.header !== ""
                ? props?.header
                : ""}
            </h5>
            <br />
            {props?.videos?.map((item) => {
              return (
                <>
                  <iframe
                    id="kmsembed-1_q8bv9hcs"
                    width="200"
                    height="100"
                    class="iframeStyle video__page__iframe kmsembed"
                    src={item?.videoSrc}
                    allowfullscreen
                    webkitallowfullscreen
                    mozAllowFullScreen
                    allow="autoplay *; fullscreen *; encrypted-media *"
                    referrerPolicy="no-referrer-when-downgrade"
                    frameborder="0"
                    title="Video"
                  ></iframe>
                  <a
                    className="link__to__newTab"
                    target="_blank"
                    href={item?.videoHref}
                    rel="noreferrer"
                  >
                    Open the video in new tab
                  </a>
                  <div className="Video_image">
                    <img
                      src="Assets/Azure/Watch out the video Icon.png"
                      className="video_innovation_image"
                      alt="TOC-img"
                    />
                  </div>
                  <br />
                </>
              );
            })}
            {props?.videoSrc && props?.videoHref && (
              <>
                <iframe
                  id="kmsembed-1_q8bv9hcs"
                  src={props?.videoSrc}
                  width="200"
                  height="100"
                  class="iframeStyle video__page__iframe kmsembed"
                  allowfullscreen
                  webkitallowfullscreen
                  mozAllowFullScreen
                  allow="autoplay *; fullscreen *; encrypted-media *"
                  referrerPolicy="no-referrer-when-downgrade"
                  frameborder="0"
                  title="Video"
                ></iframe>
                <a
                  className="link__to__newTab"
                  target="_blank"
                  href={props?.videoHref}
                  rel="noreferrer"
                >
                  Open the video in new tab
                </a>
                <div className="Video_image">
                  <img
                    src="Assets/Azure/Watch out the video Icon.png"
                    className="video_innovation_image"
                    alt="TOC-img"
                  />
                </div>
              </>
            )}
          </div>
          <div className="page_number__bottom">{props.pageNumber}</div>
        </div>
      </div>
    );
  else if (props?.courseName === "Links")
    return (
      <div className="page page__cover" ref={ref}>
        <div className="page__layout__container">
          <h5 className="intro__page__title">
            {props?.header !== "header_img2" && props?.header}
          </h5>
          <div className="usefulLInk__page__container">
            {props?.links?.map((i) => {
              if (i.link)
                return (
                  <div className="div__usefullinks">
                    <a
                      target="_blank"
                      href={i?.link}
                      rel="noopener noreferrer"
                      className="usefulLinks__page__button"
                    >
                      <img
                        className="icons__button"
                        src="Assets/Azure/icons/Hand.png"
                        alt="icon"
                      />
                      {i?.heading}
                    </a>
                  </div>
                );
              else
                return (
                  <>
                    <h6 className="introPage__Text">{i?.heading}</h6>
                    {i?.links?.map((item) => {
                      return (
                        <div className="div__usefullinks">
                          <a
                            target="_blank"
                            href={item?.link}
                            rel="noopener noreferrer"
                            className="usefulLinks__page__button"
                          >
                            <img
                              className="icons__button"
                              src="Assets/Azure/icons/Hand.png"
                              alt="icon"
                            />
                            {item?.subHeading}
                          </a>
                        </div>
                      );
                    })}
                  </>
                );
            })}
          </div>
          <div className="Usefullinks_image">
            <img
              src="Assets/Azure/Useful links Icon.png"
              className="links_innovation_image"
              alt="TOC-img"
            />
          </div>
          <div className="page_number__bottom">{props.pageNumber}</div>
        </div>
      </div>
    );
  else if (props?.courseName === "Courses At Glance") {
    const mapArray =
      props?.header !== "header_img2" && props?.header !== ""
        ? props?.glanceArray[0]
        : props?.courses;

    const getData = (courseName, attribute) => {
      const dataCourseLevel = props?.flipBookData?.pages?.find(
        (item) =>
          item?.courseName === courseName &&
          item?.course_level !== "course_img2" &&
          item?.course_level !== "",
      );
      const dataCareerLevel = props?.flipBookData?.pages?.find(
        (item) =>
          item?.courseName === courseName &&
          item?.career_level !== "career_img2" &&
          item?.career_level !== "",
      );
      const dataDuration = props?.flipBookData?.pages?.find(
        (item) =>
          item?.courseName === courseName &&
          item?.duration !== "duration_img2" &&
          item?.duration !== "",
      );
      const dataMode = props?.flipBookData?.pages?.find(
        (item) =>
          item?.courseName === courseName &&
          item?.mode !== "mode_img2" &&
          item?.mode !== "",
      );

      switch (attribute) {
        case "course_level":
          return dataCourseLevel?.course_level;
        case "career_level":
          return dataCareerLevel?.career_level;
        case "duration":
          return dataDuration?.duration;
        case "mode":
          return dataMode?.mode;
      }
    };

    return (
      <div className="page page__cover" ref={ref}>
        <div className="page__layout__container">
          {props?.header !== "header_img2" && props?.header !== "" && (
            <h5 className="intro__page__title">{props?.header}</h5>
          )}
          <table
            className={
              props?.header === "header_img2" && props?.header === ""
                ? "tableHeaderStyle CourseGlance__table"
                : "CourseGlance__table"
            }
          >
            <tr className="header__row">
              <th className="CourseGlance__Th">
                <div>
                  <img
                    className="imgHeightStyle"
                    src="Assets/Azure/icons/Sl.jpg"
                    alt="icons"
                  ></img>
                </div>
                <p>Sl.#</p>
              </th>
              <th className="CourseGlance__Th">
                <div>
                  <img
                    className="imgHeightStyle"
                    src="Assets/Azure/icons/CourseName.jpg"
                    alt="icons"
                  ></img>
                </div>
                <p>
                  Course
                  <br />
                  Name
                </p>
              </th>
              <th className="CourseGlance__Th">
                <div>
                  <img
                    className="imgHeightStyle"
                    src="Assets/Azure/icons/CourseLevel.jpg"
                    alt="icons"
                  ></img>
                </div>
                <p>Course Level</p>
              </th>
              <th className="CourseGlance__Th">
                <div>
                  <img
                    className="imgHeightStyle"
                    src="Assets/Azure/icons/CareerLevel.jpg"
                    alt="icons"
                  ></img>
                </div>
                <p>Career Level</p>
              </th>
              <th className="CourseGlance__Th">
                <div>
                  <img
                    className="imgHeightStyle"
                    src="Assets/Azure/icons/Duration.jpg"
                    alt="icons"
                  ></img>
                </div>
                <p>Hrs.</p>
              </th>
              {props?.CourseName !== "SAP" && (
                <th className="CourseGlance__Th Course__at__glance__mode">
                  <div>
                    <img
                      className="imgHeightStyle"
                      src="Assets/Azure/icons/Mode.jpg"
                      alt="icons"
                    ></img>
                  </div>
                  <p>Mode</p>
                </th>
              )}
            </tr>
            {mapArray?.map((item, index) => {
              return (
                <tr
                  onClick={() =>
                    isEven(props?.pageNumber)
                      ? props?.book?.flip(
                          getPageNum(item.courseName, props?.flipBookData) - 2,
                        )
                      : props?.book?.flip(
                          getPageNum(item.courseName, props?.flipBookData) + 2,
                        )
                  }
                  className="CourseGlance__dataRow"
                >
                  <td className="CourseGlance__data">{item?.number}</td>
                  <td className="CourseGlance__data_name">{item?.header}</td>
                  <td className="CourseGlance__data">
                    {item?.course_level !== "course_img2" &&
                    item?.course_level !== ""
                      ? item?.course_level
                      : getData(item?.courseName, "course_level")}
                  </td>
                  <td className="CourseGlance__data">
                    {item?.career_level !== "career_img2" &&
                    item?.career_level !== ""
                      ? item?.career_level
                      : getData(item?.courseName, "career_level")}
                  </td>
                  <td className="CourseGlance__data">
                    {item?.duration !== "duration_img2" && item?.duration !== ""
                      ? item?.duration
                      : getData(item?.courseName, "duration")}
                  </td>
                  {props?.CourseName !== "SAP" && (
                    <td className="CourseGlance__data">
                      {item?.mode !== "mode_img2" && item?.mode !== ""
                        ? item?.mode
                        : getData(item?.courseName, "mode")}
                    </td>
                  )}
                </tr>
              );
            })}
          </table>
          <div className="page_number__bottom">{props.pageNumber}</div>
        </div>
      </div>
    );
  } else
    return (
      <div className="page page__cover" ref={ref}>
        <div className="page__layout__container">
          <div className="page__title__Container course__page__title">
            {props.header !== "header_img2" && props.header !== "" && (
              <h5 className="page__title__main">
                {props?.number}. {props?.header?.replace(/^\d+\.\s*/, "")}
              </h5>
            )}
          </div>
          {props.header !== "header_img2" && props.header !== "" && (
            <img
              className="header__images1"
              src="Assets/Azure/Descriptioin.png"
              alt="icon"
            />
          )}
          {props.header !== "header_img2" && props.header !== "" && (
            <img
              className="banner__image__page"
              src={props.path}
              alt="banner"
            />
          )}

          {props.header === "header_img2" || props.header === "" ? (
            <div className="introPageContainer list__p">{props.li}</div>
          ) : (
            <div className="list__p">{props.li}</div>
          )}

          {(props.learningOutcome === "" &&
            props?.learningOutcomeLi?.length === 0) ||
          props.header === "header_img2" ||
          props.header === "" ? (
            ""
          ) : (
            <img
              className="header__images"
              src="Assets/Azure/lerning.png"
              alt="icon"
            />
          )}
          <div className="list__p">{props.learnOut}</div>

          {(props?.pre?.p === "" && props?.pre?.li?.length === 0) ||
          props.pre === "pre_img2" ||
          props.pre === "" ||
          props.prereq === "" ? (
            ""
          ) : (
            <img
              className="header__images"
              src="Assets/Azure/Prerequisite.png"
              alt="icon"
            />
          )}
          <div className="list__p">{props.prerequisite}</div>

          <div className="page_number__bottom">{props.pageNumber}</div>
          {props.Duration !== "duration_img2" &&
          props.Duration !== "" &&
          props.CoLevel !== "course_img2" &&
          props.CoLevel !== "" &&
          props.CaLevel !== "career_img2" &&
          props.CoLevel !== "" ? (
            <img
              className="header__images"
              src="Assets/Azure/glance.png"
              alt="icon"
            />
          ) : (
            ""
          )}
          <div className="course__at__glance__container">
            {props?.CourseName !== "SAP" &&
              props.CoCode !== "code_img2" &&
              props.CoCode !== "" && (
                <div className="courseAtGlanceDiv">
                  <img
                    className="cagImgStyle"
                    src="Assets/Azure/icons/i1.png"
                    alt="icons"
                  ></img>
                  <br></br>
                  Course Code<br></br>
                  <span className="colorStyle">{props.CoCode}</span>
                </div>
              )}
            {props.Duration !== "duration_img2" && props.Duration !== "" && (
              <div className="courseAtGlanceDiv">
                <img
                  className="cagHeightStyle"
                  src="Assets/Azure/icons/i2.png"
                  alt="icons"
                ></img>
                <br></br>
                Duration<br></br>
                <span className="colorStyle">{props.Duration}</span>
              </div>
            )}
            {props.CoLevel !== "course_img2" && props.CoLevel !== "" && (
              <div className="courseAtGlanceDiv">
                <img
                  className="cagHeightStyle"
                  src="Assets/Azure/icons/i3.png"
                  alt="icons"
                ></img>
                <br></br>
                Course Level<br></br>
                <span className="colorStyle">{props.CoLevel}</span>
              </div>
            )}
            {props.CaLevel !== "career_img2" && props.CaLevel !== "" && (
              <div className="courseAtGlanceDiv">
                <img
                  className="cagHeightStyle"
                  src="Assets/Azure/icons/i4.png"
                  alt="icons"
                ></img>
                <br></br>
                Career Levels<br></br>
                <span className="colorStyle">{props.CaLevel}</span>
              </div>
            )}
            {props?.CourseName !== "SAP" &&
              props.Mode !== "mode_img2" &&
              props.Mode !== "" && (
                <div className="courseAtGlanceDiv">
                  <img
                    className="cagDiv"
                    src="Assets/Azure/icons/i6.png"
                    alt="icons"
                  ></img>
                  <br></br>Mode<br></br>
                  <span className="colorStyle">{props.Mode}</span>
                </div>
              )}
          </div>
          {props?.header === "header_img2" &&
            props?.learningOutcome === "" &&
            props?.learningOutcomeLi?.length === 0 && (
              <img
                className="grapic__image__page"
                src={
                  props.banner &&
                  props.banner !== "graphic_img2" &&
                  props.banner !== ""
                    ? props.banner
                    : "Assets/Images/SAP/SAP-graphics-01.png"
                }
                alt="banner"
              />
            )}
        </div>
      </div>
    );
});

const PageLast = React.forwardRef((props, ref) => {
  return (
    <div className="page page__cover" ref={ref}>
      <div className="page__layout__container">
        <div>
          <div>{props.children}</div>
          <div className="page_number__bottom">{props.number}</div>
        </div>
      </div>
    </div>
  );
});

function FlipBook(props) {
  const CourseName = props?.CourseName;
  const json = props?.Json;
  const book = useRef();
  const [page, setPage] = useState(0);
  const [searchData, setSearchData] = useState([]);
  const [eventHandler, setEventHandler] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const onFlip = (e) => {
    setPage(e.data);
    if (eventHandler !== "") {
      book.current.pageFlip().flip(page);
      setEventHandler("");
    }
  };

  const searchHandler = (e) => {
    const event = e.target.value;
    setEventHandler(event);
    if (event !== "") {
      const filteredResults = SAPflipbookNewdata?.pages.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(event.toLowerCase());
      });
      const filteredResults1 = SAPflipbookNewdata?.pages.filter((item) => {
        if (item?.description !== undefined && item?.description !== null)
          return Object.values(item?.description)
            .join("")
            .toLowerCase()
            .includes(event.toLowerCase());
      });
      const filteredResults2 = SAPflipbookNewdata?.pages.filter((item) => {
        if (item?.description !== undefined && item?.description !== null)
          return Object.values(item?.description)
            .join("")
            .toLowerCase()
            .includes(event.toLowerCase());
      });
      const filteredResults3 = SAPflipbookNewdata?.pages.filter((item) => {
        if (
          item?.learning_outcomes !== undefined &&
          item?.learning_outcomes !== null
        )
          return Object.values(item?.learning_outcomes)
            .join("")
            .toLowerCase()
            .includes(event.toLowerCase());
      });
      const AllData = filteredResults.concat(
        filteredResults1,
        filteredResults2,
        filteredResults3,
      );
      setSearchData(Array.from(new Set(AllData)));
      const headerTitle = AllData.filter(
        (item) => item?.header !== "header_img2" && item?.header !== "",
      );
      setSearchData(Array.from(new Set(headerTitle)));
      const descriptionPara = AllData.filter((item) =>
        item?.description?.p1
          ? item?.description?.p?.concat(item?.description?.p1)
          : item?.description?.p,
      );
      setSearchData(Array.from(new Set(descriptionPara)));
    }
  };

  const handlepageChange = (e) => {
    const event = e.target.value;
    setPage(event);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      book.current.pageFlip().flip(parseInt(e.target.value));
    }
  };

  const toggleModal = (event) => {
    setIsOpen(!isOpen);
    setSearchData("");
  };

  const dispatch = useDispatch();
  const bookData = useSelector((state) => state.flipbookData.flipbookData);
  const SAPflipbookNewdata = json ? json : bookData;
  const loader = useSelector((state) => state.flipbookData.loader);
  const [prevData, setPrevData] = useState(null);

  const getContentsArray = (dataArray, chunkSize) => {
    let contentsArray = [];

    dataArray?.map((item) => {
      if (
        item?.courseName !== "Table of Contents" &&
        item?.courseName !== "Introduction" &&
        item?.courseName !== "Landscape" &&
        item?.courseName !== "Video" &&
        item?.courseName !== "Links" &&
        item?.courseName !== "Courses At Glance" &&
        item?.header !== "header_img2" &&
        item?.header !== ""
      )
        contentsArray.push(item);
    });
    return chunkArray(contentsArray, chunkSize);
  };

  const chunkArray = (arr, chunkSize) => {
    const result = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  };

  useEffect(() => {
    // Check if the data has changed
    if (JSON.stringify(SAPflipbookNewdata) !== JSON.stringify(prevData)) {
      dispatch(getCourseData(CourseName));
      setPrevData(SAPflipbookNewdata); // Update prevData only when data has changed
    }
  }, [SAPflipbookNewdata]);

  const loaderCondition = json
    ? SAPflipbookNewdata?.length === 0
    : loader || SAPflipbookNewdata?.length === 0;
  const footerYear = new Date().getFullYear();
  return (
    <div>
      {loaderCondition ? (
        <div className="loader">
          <CircularProgress />
        </div>
      ) : (
        <>
          {/* Header Part */}
          {!json && (
            <div class="searchnav-container">
              <div class="searchnav-wrap">
                <div class="searchnav-row">
                  <div class="searchnav-box searchNavStyle">
                    <img
                      src="Assets/Acc_Logo_Black_Purple_RGB.png"
                      class="acc-logo"
                      alt="logo"
                    />
                    <p class="desktop-tag">L&TT</p>
                    <p class="mobile-tag">L&TT</p>
                    <span className="button__container__top">
                      <button
                        className="PageNav__button"
                        type="button"
                        onClick={() =>
                          book.current
                            .pageFlip()
                            .flip(
                              getPageNum(
                                "Table of Contents",
                                SAPflipbookNewdata,
                              ),
                            )
                        }
                      >
                        Table of Contents{" "}
                      </button>
                      <button
                        className="PageNav__button"
                        type="button"
                        onClick={() =>
                          book.current
                            .pageFlip()
                            .flip(
                              getPageNum(
                                "Courses At Glance",
                                SAPflipbookNewdata,
                              ),
                            )
                        }
                      >
                        Courses at a Glance
                      </button>
                      <button
                        className="PageNav__button"
                        type="button"
                        onClick={() => book.current.pageFlip().flipPrev()}
                      >
                        Previous Page
                      </button>{" "}
                      &nbsp;&nbsp;&nbsp;&nbsp;
                      <span className="inputStyle"> </span>
                      <span className="inputStyleText">
                        <input
                          value={page}
                          pattern="^-?[0-9]\d*\.?\d*$"
                          onKeyPress={handleKeyDown}
                          onChange={handlepageChange}
                          className="pageCount_RPA"
                        />
                      </span>
                      <span className="inputStyle">
                        of {SAPflipbookNewdata?.pages?.length + 2}
                      </span>
                      <button
                        className="PageNav__button"
                        type="button"
                        onClick={() => book.current.pageFlip().flipNext()}
                      >
                        Next Page
                      </button>
                      <button
                        type="search"
                        onClick={toggleModal}
                        className="buttonStyle searching"
                      >
                        Search
                        <span className="searchIcon-round">
                          <img src="Assets/Azure/Icon feather-search.png" />
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
                <div class="searchnav-row">
                  <div class="searchnav-box searchNavStyle2">
                    <WelcomeName />
                    <img
                      src="Assets/Avatar.png"
                      class="user-img"
                      alt="user-img"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* FlipBook */}
          <div className="Main-filpbook-container">
            {json && (
              <span className="button__container__top_preview">
                <button
                  className="PageNav__button"
                  type="button"
                  onClick={() =>
                    book.current
                      .pageFlip()
                      .flip(getPageNum("Table of Contents", SAPflipbookNewdata))
                  }
                >
                  Table of Contents{" "}
                </button>
                <button
                  className="PageNav__button"
                  type="button"
                  onClick={() =>
                    book.current
                      .pageFlip()
                      .flip(getPageNum("Courses At Glance", SAPflipbookNewdata))
                  }
                >
                  Courses at a Glance
                </button>
                <button
                  className="PageNav__button"
                  type="button"
                  onClick={() => book.current.pageFlip().flipPrev()}
                >
                  Previous Page
                </button>{" "}
                &nbsp;&nbsp;&nbsp;&nbsp;
                <span className="inputStyle"> </span>
                <span className="inputStyleText">
                  <input
                    value={page}
                    pattern="^-?[0-9]\d*\.?\d*$"
                    onKeyPress={handleKeyDown}
                    onChange={handlepageChange}
                    className="pageCount_RPA"
                  />
                </span>
                <span className="inputStyle">
                  of {SAPflipbookNewdata?.pages?.length + 2}
                </span>
                <button
                  className="PageNav__button"
                  type="button"
                  onClick={() => book.current.pageFlip().flipNext()}
                >
                  Next Page
                </button>
                <button
                  type="search"
                  onClick={toggleModal}
                  className="buttonStyle searching"
                >
                  Search
                  <span className="searchIcon-round">
                    <img src="Assets/Azure/Icon feather-search.png" />
                  </span>
                </button>
              </span>
            )}

            <div className={json ? "book_container_preview" : "book_container"}>
              <HTMLFlipBook
                className="bookFlip"
                width={350}
                height={420}
                size="stretch"
                maxShadowOpacity={0.5}
                showCover={true}
                mobileScrollSupport={true}
                onFlip={onFlip}
                ref={book}
                drawShadow={true}
              >
                <PageCover
                  src={`Assets/Images/${CourseName}/${CourseName}-cover.png`}
                ></PageCover>
                {SAPflipbookNewdata?.pages?.map((item, index) => {
                  return (
                    <Page
                      CourseName={CourseName}
                      number={item.number}
                      path={item.path}
                      banner={item.banner}
                      header={item.header}
                      CoCode={item.course_code}
                      Duration={item.duration}
                      CoLevel={item.course_level}
                      CaLevel={item.career_level}
                      Mode={item.mode}
                      li={
                        <p style={{ whiteSpace: "pre-wrap" }}>
                          {item?.description?.p}
                          <ul>
                            {item?.description?.li?.map((item1, index) => {
                              return <li>{item1}</li>;
                            })}
                          </ul>
                        </p>
                      }
                      learnOut={
                        <p style={{ whiteSpace: "pre-wrap" }}>
                          {item?.learning_outcomes?.p}
                          <ul>
                            {item?.learning_outcomes?.li?.map(
                              (item1, index) => {
                                return <li>{item1}</li>;
                              },
                            )}
                          </ul>
                        </p>
                      }
                      prerequisite={
                        <p style={{ whiteSpace: "pre-wrap" }}>
                          {item?.prerequisite?.p}
                          <ul>
                            {item?.prerequisite?.li?.map((item1, index) => {
                              return <li>{item1}</li>;
                            })}
                          </ul>
                        </p>
                      }
                      prereq={item?.prerequisite?.p}
                      pre={item?.prerequisite}
                      learningOutcome={item?.learning_outcomes?.p}
                      learningOutcomeLi={item?.learning_outcomes?.li}
                      pageNumber={item?.pageNumber}
                      tableHeaders={item?.tableHeaders}
                      tableContent={item?.tableContent}
                      flipBookData={SAPflipbookNewdata}
                      introduction={item?.introduction}
                      links={item?.links}
                      coursesAtGlance={item.coursesAtGlance}
                      courseName={item.courseName}
                      book={book?.current?.pageFlip()}
                      contentsArray={getContentsArray(
                        SAPflipbookNewdata?.pages,
                        12,
                      )}
                      glanceArray={getContentsArray(
                        SAPflipbookNewdata?.pages,
                        11,
                      )}
                      courses={item?.courses}
                      videoSrc={item?.videoSrc}
                      videoHref={item.videoHref}
                      videos={item?.videos}
                    ></Page>
                  );
                })}
                {isEven(SAPflipbookNewdata?.pages?.length) ? (
                  <PageLast>
                    <img
                      className="cover__image__graphic"
                      src={`Assets/Images/${props?.CourseName}/${props?.CourseName}-full-page-graphics.png`}
                      alt="last"
                    />
                  </PageLast>
                ) : (
                  <></>
                )}
                <PageLast>
                  <div className="last_page_section">
                    <img
                      className="cover__image__size"
                      src="Assets/RPA/LastPage_updated.png"
                      alt="last"
                    />
                    <p className="last_page_para">
                      <span>
                        ©{footerYear} Accenture All Rights Reserved. For
                        Internal Use Only.
                      </span>
                      <span>Conceptualized and Designed by LX, L&TT</span>
                    </p>
                  </div>
                </PageLast>
                {/* <PageLast>
                                    <img
                                        className="cover__image__size"
                                        src="Assets/Azure/last.jpg"
                                        alt="last"
                                    />
                                </PageLast> */}
              </HTMLFlipBook>
            </div>
            {eventHandler.length >= 0 && (
              <div className="searchbar-container">
                <div className="searchbar-wrapper">
                  <Modal isOpen={isOpen} onRequestClose={toggleModal}>
                    <div className="searchingInner">
                      <p className="searchIconTitle">Search the Courses</p>
                      <input
                        type="search"
                        onChange={searchHandler}
                        className="searching buttonStyle"
                        placeholder="Search Courses..."
                        value={eventHandler}
                      />
                      <span className="searchIcon">
                        <img src="Assets/Azure/Icon feather-search.png" />
                      </span>
                    </div>

                    <button
                      onClick={() => {
                        toggleModal();
                        setEventHandler("");
                      }}
                      className="closeIcon"
                    >
                      X
                    </button>
                    {searchData.length === 0 && eventHandler.length !== 0 ? (
                      <h3 className="resultsfound">No Results Found</h3>
                    ) : (
                      ""
                    )}
                    {searchData.length !== 0 &&
                      searchData.map((item) => {
                        let newTitle = item.header.replace(
                          new RegExp(eventHandler, "gi"),
                          (match) =>
                            `<span style='background-color: yellow','padding: 2px 2px'>${match}</span>`,
                        );
                        let newTitle1 = item.description.p
                          .concat(item.description.p1)
                          .replace(
                            new RegExp(eventHandler, "gi"),
                            (match) =>
                              `<span style='background-color: yellow','padding: 2px 2px'>${match}</span>`,
                          );
                        let newTitle2 = "";
                        let newTitle3 = "";

                        if (item.learning_outcomes.p !== "") {
                          newTitle2 = item.learning_outcomes.p.replace(
                            new RegExp(eventHandler, "gi"),
                            (match) =>
                              `<span style='background-color: yellow','padding: 2px 2px'>${match}</span>`,
                          );
                          newTitle3 = item.learning_outcomes.li
                            .toString()
                            .replace(
                              new RegExp(eventHandler, "gi"),
                              (match) =>
                                `<span style='background-color: yellow','padding: 2px 2px'>${match}</span>`,
                            );
                        } else {
                          let pgNumInc = parseInt(item.number) + 1;
                          var objResult = SAPflipbookNewdata?.pages.find(
                            function (e) {
                              return e.number == pgNumInc;
                            },
                          );
                          newTitle2 = objResult.learning_outcomes.p.replace(
                            new RegExp(eventHandler, "gi"),
                            (match) =>
                              `<span style='background-color: yellow','padding: 2px 2px'>${match}</span>`,
                          );
                          newTitle3 = objResult.learning_outcomes.li
                            .toString()
                            .replace(
                              new RegExp(eventHandler, "gi"),
                              (match) =>
                                `<span style='background-color: yellow','padding: 2px 2px'>${match}</span>`,
                            );
                        }

                        let DesImg = item.header !== "header_img2" &&
                          item.header !== "" && (
                            <img
                              className="header__images1"
                              src="Assets/Azure/Descriptioin.png"
                              alt="icon"
                            />
                          );
                        let LearnImg = item.header !== "header_img2" &&
                          item.header !== "" && (
                            <img
                              className="header__images1"
                              src="Assets/Azure/lerning.png"
                              alt="icon"
                            />
                          );
                        const popupClose = (e) => {
                          toggleModal();
                          book.current.pageFlip().flip(parseInt(item.number));
                          setPage(parseInt(item.number));
                        };

                        return (
                          <>
                            <div className="search-list">
                              <a className="search-link" onClick={popupClose}>
                                <p
                                  dangerouslySetInnerHTML={{ __html: newTitle }}
                                  className="search-header"
                                ></p>
                                <p className="search-ccode">{DesImg}</p>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: newTitle1,
                                  }}
                                  className="searchText"
                                ></p>
                                <p className="search-ccode">{LearnImg}</p>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: newTitle2,
                                  }}
                                  className="searchText"
                                ></p>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: newTitle3,
                                  }}
                                  className="searchText"
                                ></p>
                              </a>
                            </div>
                          </>
                        );
                      })}
                    <button
                      onClick={() => {
                        toggleModal();
                        setEventHandler("");
                      }}
                      className="modalClose"
                    >
                      Close
                    </button>
                  </Modal>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default FlipBook;
